import Box from '@mui/material/Box';

/**
 * A white-paper card with the canonical border + 8px radius.
 *
 * Replaces the open-coded pattern:
 *   <Box sx={{ backgroundColor: 'var(--paper)', border: '1px solid var(--grey-200)', borderRadius: '8px', ...rest }}>
 *
 * Any `sx` prop passed in is merged on top of the defaults, so per-site
 * tweaks (padding, flex layout, overflow, hover rules, etc.) work as before.
 *
 * @param {{ sx?: object, children?: React.ReactNode, [key: string]: any }} props
 */
export default function ContentCard({ sx, children, ...rest }) {
  return (
    <Box
      sx={{
        backgroundColor: 'var(--paper)',
        border: '1px solid var(--grey-200)',
        borderRadius: '8px',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
